<template>
  <div>
    <label for="bookingVoucherSelected"
      >Voucher<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingVoucherSelected"
      v-model="voucher"
      :options="vouchers"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingVoucherDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    bookingId: { type: Number, default: null },
    serviceId: { type: Number, default: null },
    privilegeId: { type: Number, default: null },
    customerCode: { type: String, default: null },
    storeCode: { type: String, default: null },
    date: { type: String, default: null },
  },
  data() {
    return {
      voucher: this.value,
      vouchers: [],
    };
  },
  created() {
    if (this.serviceId && this.customerCode) {
      this.getVouchers(
        this.bookingId,
        this.serviceId,
        this.privilegeId,
        this.customerCode,
        this.storeCode,
        this.date
      );
    }
  },
  watch: {
    voucher(newValue) {
      this.$emit("setVoucher", newValue);
    },
    value(newValue) {
      this.voucher = newValue;
    },
    vouchers(newValue) {
      this.$emit("setVouchers", newValue);
    },
    serviceId(newServiceId) {
      if (newServiceId && this.customerCode) {
        this.getVouchers(
          this.bookingId,
          newServiceId,
          this.privilegeId,
          this.customerCode,
          this.storeCode,
          this.date
        );
      } else {
        this.clearVouchers();
      }
    },
    privilegeId(newPrivilegeId) {
      if (this.serviceId && this.customerCode) {
        this.getVouchers(
          this.bookingId,
          this.serviceId,
          newPrivilegeId,
          this.customerCode,
          this.storeCode,
          this.date
        );
      } else {
        this.clearVouchers();
      }
    },
    customerCode(newCustomerCode) {
      if (this.serviceId && newCustomerCode) {
        this.getVouchers(
          this.bookingId,
          this.serviceId,
          this.privilegeId,
          newCustomerCode,
          this.storeCode,
          this.date
        );
      } else {
        this.clearVouchers();
      }
    },
    storeCode(newStoreCode) {
      if (this.serviceId && this.customerCode) {
        this.getVouchers(
          this.bookingId,
          this.serviceId,
          this.privilegeId,
          this.customerCode,
          newStoreCode,
          this.date
        );
      } else {
        this.clearVouchers();
      }
    },
    date(newDate) {
      if (this.serviceId && this.customerCode && newDate) {
        this.getVouchers(
          this.bookingId,
          this.serviceId,
          this.privilegeId,
          this.customerCode,
          this.storeCode,
          newDate
        );
      } else {
        this.clearVouchers();
      }
    },
  },
  methods: {
    async getVouchers(
      bookingId,
      serviceId,
      privilegeId,
      customerCode,
      storeCode,
      date
    ) {
      try {
        emitLoadingStart(this);
        await BookingService.getVouchers({
          bookingId: bookingId,
          serviceId: serviceId,
          privilegeId: privilegeId,
          customerCode: customerCode,
          storeCode: storeCode,
          date: date,
        })
          .then(async (res) => {
            const data = await res.data;
            this.vouchers = data.items
              .map((s) => {
                return {
                  id: s.key,
                  text: s.value,
                  no: s.no,
                  expiry: s.expiry,
                  privilegeId: s.privilegeId,
                  privilegeName: s.privilegeName,
                  privilegeType: s.privilegeType,
                };
              })
              .sort(function (a, b) {
                return a.expiry.localeCompare(b.expiry);
              });
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
    clearVouchers() {
      this.vouchers = [];
    },
  },
};
</script>
